// extracted by mini-css-extract-plugin
export default {"primary":"BinButton_primary__35LrJ"};